function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import euUser from './eu';
import identity from './identity';
import watchlistApi from './watchlist-api';
import inspectionApi from './inspection-api';
import authentication from './authentication';
import toggledFeatures from './toggled-features';
import propertyAlerts from './property-alerts';
import functions from './functions';
import userPreferences from './user-preferences';
import locality from './locality';
import analytics from './analytics';
import myahApi from './my-allhomes-api';
import pageContext from './page-context';
import apolloClient from './apollo-client';
import ads from './ads';
import logging from './logging';

/* eslint-disable id-length */

/**
 * These are props passed directly to the AllhomesAPIProvider that shouldn't pollute the namespace of the
 * wrapped component
 */
var consumedProps = new Set(['isEuUser', 'onAddToWatchlist', 'isProduction', 'reloadOnLogin', 'toggledFeatures', 'activeExperiments', 'tokenCookie', 'casualUserCookie', 'absoluteUrlBase', 'apolloClient', 'pageContext', 'logLevels']);
export var allhomesApiFilteredProps = props => Object.keys(props).reduce((result, key) => consumedProps.has(key) ? result : _objectSpread(_objectSpread({}, result), {}, {
  [key]: props[key]
}));
var contextFactory = (baseProps, nonPromiseUpdateContext, getContext) => {
  var updateListeners = new Set();
  var addListener = listener => {
    updateListeners.add(listener);
  };
  var removeListener = listener => {
    updateListeners.delete(listener);
  };
  var notifyListeners = () => {
    updateListeners.forEach(listener => {
      try {
        listener();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.debug('Caught exception calling context update listener', error);
      }
    });
  };
  var updateContext = (newValue, after) => after ? nonPromiseUpdateContext(newValue, () => {
    after();
    notifyListeners();
  }) : new Promise(resolve => {
    nonPromiseUpdateContext(newValue, () => {
      notifyListeners();
      resolve();
    });
  });
  var funcs = functions(baseProps, updateContext, getContext);
  var loggingFeature = logging(baseProps, updateContext, getContext);
  var props = _objectSpread(_objectSpread({}, baseProps), {}, {
    shared: _objectSpread(_objectSpread({}, funcs), {}, {
      getLogger: loggingFeature.getLogger,
      addListener,
      removeListener
    })
  });
  var isProduction = props.isProduction;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, euUser(props)), toggledFeatures(props)), identity(props, updateContext, getContext)), apolloClient(props, updateContext, getContext)), watchlistApi(props, updateContext, getContext)), inspectionApi(props, updateContext, getContext)), authentication(props, updateContext, getContext)), userPreferences(props, updateContext, getContext)), propertyAlerts(props)), funcs), analytics(props, updateContext, getContext)), locality(props, updateContext, getContext)), myahApi(props, updateContext, getContext)), pageContext(props, updateContext, getContext)), ads(props, updateContext, getContext)), loggingFeature), {}, {
    isProduction
  });
};
export default contextFactory;